import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { Panel, Theme } from '@pga/pga-component-library'
import { Title } from '../common/styled'

export const OverviewWrapped = styled(Panel)`
  display: flex;
  flex-direction: row;
  height: ${props => props.readMore ? 'auto' : '360px'};
  overflow: hidden;
  justify-content: flex-start;
  margin: 0;
  box-shadow: 0px 0px 0px 0px;
`

export const Flex = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  height: ${props => props.readMore ? 'auto' : '550px'};
  margin-top: 10px;
  margin-left: 30px;
  background-color: white;
  box-shadow: 0 5px 10px 0 ${Theme.colors.primaryShadow};
  @media screen and (max-width: 767px) {
    margin: 0 0 30px 0;
  }
`

export const ReadMoreDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-top: 1px solid ${Theme.colors.pearlGrey};
  height: 40px;
`

export const Text = styled.p`
  font-family: ${Theme.fonts.Montserrat};
  font-size: ${props => props.large ? '14' : '12'}px;
  color: ${props => props.lightBlue ? Theme.colors.lightBlue : Theme.colors.blueGrey};
  cursor: pointer;
  font-weight: 500;
  ${props => props.noMargin && 'margin: 0px;'}
`

const AngleDown = styled.i.attrs({
  className: 'fa fa-angle-down fa-lg'
})`
  padding: 0 5px;
`
const AngleUp = styled.i.attrs({
  className: 'fa fa-angle-up fa-lg'
})`
  padding: 0 5px;
`

const ReadMore = () => <span>Read More<AngleDown /></span>
const ReadLess = () => <span>Read Less<AngleUp /></span>

const useOverviewWidth = () => {
  const [overflow, setOverflow] = useState(false)
  const setWidth = useCallback(node => {
    if (node !== null) {
      setOverflow(node.getBoundingClientRect().height > 400)
    }
  }, [])
  return [overflow, setWidth]
}

export default ({ hit = {} }) => {
  const [readMore, toggleReadMore] = useState(false)
  const [overflow, setWidth] = useOverviewWidth()
  return (
    <Flex readMore={readMore}>
      <OverviewWrapped readMore={readMore}>
        <div ref={setWidth}>
          <Title pl='0' pt='0' pb='30px'>OVERVIEW</Title>
          <Text
            large
            dangerouslySetInnerHTML={{ __html: hit.overview }}
          />
        </div>
      </OverviewWrapped>
      {overflow && <ReadMoreDiv>
        <Text
          lightBlue
          noMargin
          onClick={() => toggleReadMore(!readMore)}
        >{readMore ? <ReadLess /> : <ReadMore />}</Text>
      </ReadMoreDiv>}
    </Flex>
  )
}
